const ImportExtensionTranslations = (extensionName, translations) => {
    try {
        const verified = {};
        const corrupted = {};
        Object.keys(translations).forEach((transitionName) => {
            const transitionObject = translations[transitionName];
            Object.keys(transitionObject).forEach((key) => {
                if (key.startsWith(`ext.${extensionName}`)) {
                    verified[transitionName] = {
                        ...verified[transitionName],
                        [key]: transitionObject[key],
                    };
                }
                else {
                    corrupted[transitionName] = {
                        ...corrupted[transitionName],
                        [key]: transitionObject[key],
                    };
                }
            });
            if (Object.keys(corrupted).length) {
                console.error(`${JSON.stringify(corrupted)} - translations are incorrect`);
            }
        });
        return verified;
    }
    catch (error) {
        console.error(error);
    }
};
export default ImportExtensionTranslations;
